import { useIsMobile } from "src/app/hooks/useIsMobile";

const DrawerAwareContainerComponentViewModel = () => {
  const isMobile: boolean = useIsMobile();
  return { isMobile };
};

export default DrawerAwareContainerComponentViewModel;
